var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticClass:"page-a4 container elevation-5",attrs:{"size":"A4"}},_vm._l((_vm.prototypes),function(prototype){return _c('packing-list-for-export',{key:prototype.id,attrs:{"prototype":prototype}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }